<template>
  <div class="legal-page">
    <Navigation />

    <h1>{{ $t('legal.terms.title') }}</h1>

    <section class="legal-section">
      <p class="legal-basis">{{ $t('legal.terms.legalBasis') }}</p>

      <h2>{{ $t('legal.terms.scopeTitle') }}</h2>
      <p>{{ $t('legal.terms.scopeText') }}</p>

      <h2>{{ $t('legal.terms.servicesTitle') }}</h2>
      <p>{{ $t('legal.terms.servicesText') }}</p>

      <h2>{{ $t('legal.terms.contractTitle') }}</h2>
      <p>{{ $t('legal.terms.contractText') }}</p>

      <h2>{{ $t('legal.terms.pricesTitle') }}</h2>
      <p>{{ $t('legal.terms.pricesText') }}</p>

      <h2>{{ $t('legal.terms.liabilityTitle') }}</h2>
      <p>{{ $t('legal.terms.liabilityText') }}</p>

      <h2>{{ $t('legal.terms.cancellationTitle') }}</h2>
      <p>{{ $t('legal.terms.cancellationText') }}</p>

      <h2>{{ $t('legal.terms.aiTitle') }}</h2>
      <p>{{ $t('legal.terms.aiText') }}</p>

      <h2>{{ $t('legal.terms.lawTitle') }}</h2>
      <p>{{ $t('legal.terms.lawText') }}</p>

      <h2>{{ $t('legal.terms.contactTitle') }}</h2>
      <p>{{ $t('legal.terms.contactText') }}</p>
      <p>{{ $t('legal.imprint.email') }}</p>
      <p>{{ $t('legal.imprint.phone') }}</p>
    </section>

    <LegalFooter />
  </div>
</template>

<script>
import Navigation from '../sections/Navigation.vue'
import LegalFooter from './LegalFooter.vue'

export default {
  name: 'LegalAGB',
  components: { Navigation, LegalFooter }
}
</script>

<style scoped>
.legal-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 120px 20px 0;
  color: #e2e8f0;
  min-height: 100vh;
}

h1 {
  font-size: 3rem;
  margin-bottom: 40px;
  color: #ffffff;
  text-align: center;
  font-weight: 700;
}

.legal-section {
  background: rgba(15, 16, 35, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.4);
  margin-bottom: 30px;
}

.legal-basis {
  font-size: 0.9rem;
  opacity: 0.8;
  margin-bottom: 24px;
}

h2 {
  color: #ffffff;
  margin: 30px 0 15px;
  font-size: 1.5rem;
  font-weight: 600;
  border-bottom: 2px solid #00ffb3;
  padding-bottom: 8px;
}

p {
  margin: 10px 0;
  line-height: 1.6;
  color: #e2e8f0;
}

@media (max-width: 768px) {
  .legal-page {
    padding-top: 100px;
  }

  h1 {
    font-size: 2.5rem;
  }

  .legal-section {
    padding: 30px 20px;
  }
}
</style>
